import { restDelete, restGet, restPost, restPut } from "apiCommandsExecutor/rest";

import {
    BranchAccountDto,
    ImpersonationTokenDto,
    OrganizationBranchDto,
    OrganizationBranchesPageDto,
} from "./restModels";
import {
    BranchAccountPhoneNumberRequestDto,
    OrganizationBranchesListParams,
    UpdateBranchFeaturesRequestDto,
    UpdateBranchNameRequestDto,
    UpdateBranchPartnerRequestDto,
    UpdateBranchTariffRequestDto,
} from "./restRequests";

/*
* Пустые фильтры не отправляем вовсе: бэк отличает «не ограничиваем» от значения, а пустая
* строка в query дала бы поиск по пустому названию.
* */
export const getOrganizationBranches = (params: OrganizationBranchesListParams) =>
    restGet<OrganizationBranchesPageDto>("/organization-branches", {
        organizationBranchId: params.organizationBranchId || undefined,
        query: params.query || undefined,
        paymentStatus: params.paymentStatus || undefined,
        partnerId: params.partnerId || undefined,
        skip: params.skip,
        limit: params.limit,
    });

export const getOrganizationBranch = (id: number) =>
    restGet<OrganizationBranchDto>(`/organization-branches/${id}`);

export const updateBranchName = (id: number, body: UpdateBranchNameRequestDto) =>
    restPut<OrganizationBranchDto>(`/organization-branches/${id}/name`, body);

export const updateBranchTariff = (id: number, body: UpdateBranchTariffRequestDto) =>
    restPut<OrganizationBranchDto>(`/organization-branches/${id}/tariff`, body);

export const updateBranchFeatures = (id: number, body: UpdateBranchFeaturesRequestDto) =>
    restPut<OrganizationBranchDto>(`/organization-branches/${id}/features`, body);

export const updateBranchPartner = (id: number, body: UpdateBranchPartnerRequestDto) =>
    restPut<OrganizationBranchDto>(`/organization-branches/${id}/partner`, body);

export const removeBranchPartner = (id: number) =>
    restDelete<OrganizationBranchDto>(`/organization-branches/${id}/partner`);

export const createImpersonationToken = (id: number) =>
    restPost<ImpersonationTokenDto>(`/organization-branches/${id}/impersonation-token`);

export const getBranchAccounts = (id: number) =>
    restGet<BranchAccountDto[]>(`/organization-branches/${id}/accounts`);

export const addBranchAccount =(id: number, body: BranchAccountPhoneNumberRequestDto) =>
    restPost<BranchAccountDto[]>(`/organization-branches/${id}/accounts`, body);

export const updateBranchAccountPhoneNumber = (
    id: number,
    accountId: number,
    body: BranchAccountPhoneNumberRequestDto
) =>
    restPut<BranchAccountDto[]>(
        `/organization-branches/${id}/accounts/${accountId}/phone-number`,
        body
    );

export const deleteBranchAccount = (id: number, accountId: number) =>
    restDelete<BranchAccountDto[]>(`/organization-branches/${id}/accounts/${accountId}`);
